import { createFileRoute, redirect } from '@tanstack/react-router'
import mobile from 'is-mobile'
import { z } from 'zod'
import { assetQuery } from '../../data/assets.ts'

export const Route = createFileRoute('/_redirects/asset')({
	validateSearch: z.object({ vrn: z.string() }),
	loaderDeps: ({ search }) => ({ vrn: search.vrn }),
	loader: async ({ context: { queryClient }, deps: { vrn } }) => {
		const assets = await queryClient.ensureQueryData(assetQuery(undefined))
		const matchingAsset = assets.find((a) => a.vrn === vrn)

		if (mobile()) throw redirect({ to: '/m/map', search: { locationId: matchingAsset?.id } })
		throw redirect({ to: '/', search: { locationId: matchingAsset?.id, panel: matchingAsset ? 'alerts' : undefined } })
	},
})
